import { graphql } from '@guuru/graphql-common/gql';
import { CHAT_PUBLIC_FIELDS, CHAT_MESSAGE_FIELDS } from '@guuru/graphql-web';

export default graphql(
  `
    subscription ChatUpdated(
      $id: ID!
      $isVisibleByExpert: Boolean
      $isVisibleByUser: Boolean
    ) {
      chatUpdated(id: $id) {
        id
        ...ChatPublicFields
        messages(
          isVisibleByExpert: $isVisibleByExpert
          isVisibleByUser: $isVisibleByUser
          orderBy: { direction: asc, field: createdAt }
        ) {
          edges {
            node {
              ...MessageFields
            }
          }
        }
      }
    }
  `,
  [CHAT_PUBLIC_FIELDS, CHAT_MESSAGE_FIELDS],
);
